<template>
  <div class="fisSectionTitle">No Cost Centers found</div>
  <div>
    The Facilities Work Search is restricted to active members of the Yale
    community. If you believe you are receiving this message in error please
    contact your supervisor.
  </div>
</template>

<style>
#app {
  margin-top: 60px;
}
[v-cloak] {
  display: none !important;
}
</style>
<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['user']),
  },
};
</script>
